import React from "react";

import Background from "../../../assets/market/market-bg-03.png";
import Image from "../../../assets/market/market-02-choice-b.png";

import GamePageLayout from "../GamePageLayout";

const MarketPage6 = ({ setCurrentPage }) => {
  return (
    <GamePageLayout
      bg={Background}
      img={Image}
      onClickNext={() => setCurrentPage("clothes-1")}
    >
      아...
      <br />
      날도 더운데 하루면 오는 배송
      <br />
      너무 편해 포기할 수 없어~
    </GamePageLayout>
  );
};

export default MarketPage6;
